<span class="tab-label" *ngIf="config">
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">

        <circle *ngIf="tab == 'PARALLEL_WORKFLOW'" cx="1.8" cy="10" r="1.5" stroke="#0F3659"
            [attr.stroke-width]="active ? config.activeWidth : config.inactiveWidth" />

        <path [attr.d]="config.path" [attr.stroke]="config.stroke"
            [attr.stroke-width]="active ? config.activeWidth : config.inactiveWidth" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    &nbsp;
    <span>{{ label }}</span>
</span>